exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#NewUserLayer *{font-size:12px}#NewUserLayer .list--el--bold{font-weight:700;color:rgba(0,0,0,.54)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-242a86fc","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/edition/modals/NewUserLayer.vue
// module id = 2185
// module chunks = 0